import { Status, getHoursLeftToExpire, DownloadActionTypes, ReportModule } from "@/global";
import { ReportDownloadAction } from "@/global/interfaces";

export const getStatusIcon = (status: string) => {
  switch (status) {
    case Status.SUCCESSFUL:
      return "check";
    case Status.FAILED:
      return "times";
    default:
      return "progress";
  }
};
export const getTagAppearance = (status: string) => {
  switch (status) {
    case Status.SUCCESSFUL:
      return "success";
    case Status.FAILED:
      return "failed";
    default:
      return "progress";
  }
};
export const getBackgroundColor = (status: string) => {
  switch (status) {
    case Status.SUCCESSFUL:
      return "var(--mds_brand_appearance_success_default_text-color)";
    case Status.FAILED:
      return "var(--mds_brand_appearance_error_default_border-color)";
    default:
      return "var(--mds_brand_appearance_primary_default_background-color)";
  }
};

export const getAction = (
  status: string,
  downloadUrl?: string,
  moduleName: ReportModule = ReportModule.DOWNLOAD
): ReportDownloadAction[] => {
  if (status === Status.FAILED && moduleName === ReportModule.DOWNLOAD) {
    return [
      {
        label: DownloadActionTypes.DELETE
      }
    ];
  } else if (status === Status.FAILED && moduleName === ReportModule.UPLOAD) {
    return [
      {
        label: "DOWNLOAD_ERROR_REPORT",
        url: downloadUrl
      },
      {
        label: DownloadActionTypes.DELETE
      }
    ];
  } else if (status === Status.SUCCESSFUL && moduleName === ReportModule.DOWNLOAD) {
    return [
      {
        label: "DOWNLOAD",
        url: downloadUrl
      }
    ];
  }
  return [];
};

export const getTag = (status: string, expiry?: string | number | Date) => {
  if (status !== Status.SUCCESSFUL || !expiry) return;

  const timeLeft = getHoursLeftToExpire(expiry);

  // Handle object case
  if (typeof timeLeft === "object" && timeLeft !== null) {
    const keys = Object.keys(timeLeft);

    //  Empty object → use fallback
    if (keys.length === 0) {
      return {
        key: "NOTIFICATION.EMISSIONS_CONSTANTS.PEER_BENCHMARKING.DETAILED_ANALYSIS.NA"
      };
    }

    const key = keys[0];
    const value = timeLeft[key];

    return {
      key: "NOTIFICATION.EXPIRY_TIME",
      params: {
        daysLeft: value,
        timeUnit: key
      }
    };
  }

  // Non-object fallback case
  if (timeLeft) {
    return { text: timeLeft }; // Direct text, no translation needed
  }

  return {
    key: "NOTIFICATION.EMISSIONS_CONSTANTS.PEER_BENCHMARKING.DETAILED_ANALYSIS.NA"
  };
};
